const countFormatter = new Intl.NumberFormat('fr-FR');

/** Integer count in French notation ("12 345"); a quantity the call did not measure shows "—". */
const formatCount = (count: number | null): string => {
	if (count === null) {
		return '—';
	}

	return countFormatter.format(count);
};

export default formatCount;
